import Image from "next/image";
import logo from "./../../public/logo-poweredby.svg";
import styles from "./WidgetHeader.module.scss";

const WidgetHeader = (props) => {
  return (
    <div className={styles.HeaderBox} onClick={props.ctaClick}>
      {/* title */}
      <div className={styles.HeadingTitle}>{props.title}</div>

      {/* Powered by icon */}
      <div className={styles.HeaderIcon}>
        {/* <div className={styles.LogoText}>powered by</div> */}
        <Image
          className={styles.Logo}
          src={logo}
          alt="Powered by WazirX"
          height="31px"
          width="93px"
        />
      </div>
    </div>
  );
};

export default WidgetHeader;
